import React, { Component, useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import {
  selectZoomCourseType,
  updateCourseStudentsEventsIds
} from '../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import GetAppIcon from '@material-ui/icons/GetApp'
import Box from '@material-ui/core/Box'

import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import BrowserStore from 'store'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Grid from '@material-ui/core/Grid'

import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import SearchIcon from '@material-ui/icons/Search'
import DirectionsIcon from '@material-ui/icons/Directions'
import InputBase from '@material-ui/core/InputBase'
import Divider from '@material-ui/core/Divider'

import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import CircularProgress from '@material-ui/core/CircularProgress'

import { getSearchUsers } from '../../services/saga'
import Alert from '@material-ui/lab/Alert'
import Collapse from '@material-ui/core/Collapse'
import CloseIcon from '@material-ui/icons/Close'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    // padding: '2px 4px',
    display: 'flex',
    // alignItems: 'center',
    width: 400
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  }
}))

function StepOne(props) {
  const classes = useStyles()

  // const { data, onTabChange, oninputTextChanges } = props;

  const userData = BrowserStore.get('inseadCanvasAdmin')

  const [value, setValue] = React.useState('')

  const [loading, setLoading] = React.useState(false)
  const [searchResults, setSearchResults] = React.useState([])

  const [openAlert, setOpenAlert] = React.useState(false)

  const handleInputChange = (event) => {
    let inputText = event.target.value

    let dataSet = {
      inputText: inputText,
      requestedBy: userData.sub_account.email
    }

    setValue(inputText)
  }

  const onClickSearch = async (e) => {
    e.preventDefault()
    setLoading(true)

    let search = await getSearchUsers(value)
    setLoading(false)
    setSearchResults(search.data)

    setOpenAlert(true)
  }

  return (
    <React.Fragment>
      <Paper component='form' className={classes.root} onSubmit={onClickSearch}>
        <IconButton className={classes.iconButton} aria-label='menu'>
          <PeopleOutlineIcon />
        </IconButton>
        <InputBase
          className={classes.input}
          placeholder='Search Users'
          inputProps={{ 'aria-label': 'search users' }}
          onChange={handleInputChange}
        />
        <IconButton
          onClick={onClickSearch}
          type='submit'
          className={classes.iconButton}
          aria-label='search'
        >
          {loading === true ? <CircularProgress size={24} /> : <SearchIcon />}
        </IconButton>
      </Paper>

      <br />

      {searchResults.length === 0 ? (
        <Collapse in={openAlert}>
          <Alert
            severity='info'
            action={
              <IconButton
                aria-label='close'
                color='inherit'
                size='small'
                onClick={() => {
                  setOpenAlert(false)
                }}
              >
                <CloseIcon fontSize='inherit' />
              </IconButton>
            }
          >
            No Users Found.
          </Alert>
        </Collapse>
      ) : null}

      <br />

      <Grid container spacing={3}>
        {searchResults.length !== 0 ? (
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              size='small'
              aria-label='a dense table'
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align='right'>Name</TableCell>
                  <TableCell align='right'>Login Id</TableCell>
                  <TableCell align='right'>SIS ID</TableCell>
                  <TableCell align='right'>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell component='th' scope='row'>
                      {row.id}
                    </TableCell>
                    <TableCell align='right'>{row.name}</TableCell>
                    <TableCell align='right'>{row.login_id}</TableCell>
                    <TableCell align='right'>{row.sis_user_id}</TableCell>
                    <TableCell align='right'>{row.created_at}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}
      </Grid>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CourseStudentExport
  }
}

const mapDispatchToProps = (dispatch) => ({
  oninputTextChanges: (ids) => {
    dispatch(updateCourseStudentsEventsIds(ids))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StepOne)
